"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_blurhash_1 = require("react-blurhash");
var Lazy_1 = __importDefault(require("../../../utils/Lazy"));
var styles_1 = require("../Img/styles");
var utils_1 = require("../utils");
var styles_2 = require("./styles");
var Picture = function (_a) {
    var alt = _a.alt, _b = _a.isRounded, isRounded = _b === void 0 ? false : _b, fit = _a.fit, aspectRatio = _a.aspectRatio, position = _a.position, backgroundColor = _a.backgroundColor, _c = _a.sources, sources = _c === void 0 ? [] : _c, blurHash = _a.blurHash, _d = _a.lazy, lazy = _d === void 0 ? false : _d, commonProps = __rest(_a, ["alt", "isRounded", "fit", "aspectRatio", "position", "backgroundColor", "sources", "blurHash", "lazy"]);
    var src = react_1.default.useMemo(function () { return sources[sources.length - 1].srcSet.split(', ')[0].replace(' 1x', ''); }, [sources]);
    var _e = __read((0, react_1.useState)(function () { return utils_1.cache.exists(src); }), 2), loaded = _e[0], setLoaded = _e[1];
    var handleLoaded = function () {
        utils_1.cache.add(src);
        setLoaded(true);
    };
    return (react_1.default.createElement(Lazy_1.default, { skip: !lazy, triggerOnce: true, rootMargin: "20%" }, function (_a) {
        var ref = _a.ref, inView = _a.inView;
        return (react_1.default.createElement(styles_2.Wrapper, __assign({ "data-component-name": "Picture" }, commonProps, { ref: ref, "$isRounded": isRounded, "$fit": fit, "$aspectRatio": aspectRatio, "$position": position, "$backgroundColor": backgroundColor, "$loaded": loaded }),
            blurHash && (react_1.default.createElement(styles_1.BlurhashWrapper, null,
                react_1.default.createElement(react_blurhash_1.Blurhash, { hash: blurHash }))),
            (!lazy || inView) && (react_1.default.createElement(styles_2.Pic, null,
                sources.map(function (source, i) { return (react_1.default.createElement("source", { key: i, srcSet: source.srcSet, type: source.type, media: source.media })); }),
                react_1.default.createElement("img", { src: src, alt: alt, ref: function (e) {
                        if (e === null || e === void 0 ? void 0 : e.complete) {
                            handleLoaded();
                        }
                    }, onLoad: handleLoaded })))));
    }));
};
exports.default = Picture;
